import React, { useEffect, useState } from "react";
import SummaryApi from "../../../common";

const UmedwarPage = () => {
  const [umedwars, setUmedwars] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);

  const [formData, setFormData] = useState({
    fullName: "",
    mobile: "",
    role: "CANDIDATE",
    pad: "",
    accessKey: "",
    amount: "",
    pakshaPhoto: "", 
    allowedColumns: [],
  });

  const allColumns = [
    "Sr.No.",
    "नाव",
    "नाते",
    "Epic No.",
    "लिंग",
    "Part No",
    "Mobile No.",
    "जात",
    "कामे",
    "other",
    "Mark",
    "Status",
  ];

  // ✅ Fetch all Umedwars
  const fetchUmedwars = async () => {
    try {
      const res = await fetch(SummaryApi.GetUmedwar.url);
      const data = await res.json();
      setUmedwars(data);
    } catch (err) {
      console.error("Error fetching Umedwars:", err);
    }
  };

  useEffect(() => {
    fetchUmedwars();
  }, []);

  // ✅ Handle Create or Update
const handleSubmit = async (e) => {
    e.preventDefault();

    const url = editingId
      ? `${SummaryApi.UpdateUmedwar.url}/${editingId}`
      : SummaryApi.CreatedUmedwar.url;

    const method = editingId ? "PUT" : "POST";

    try {
      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await res.json();

      if (res.ok) {
        alert(editingId ? "Umedwar updated!" : "Umedwar created!");
        setShowForm(false);
        setEditingId(null);
        resetForm();
        fetchUmedwars();
      } else {
        alert(result.message || "Operation failed");
      }
    } catch (err) {
      console.error("Error:", err);
      alert("Something went wrong!");
    }
  };

  const resetForm = () => {
    setFormData({
      fullName: "",
      mobile: "",
      role: "CANDIDATE",
      pad: "",
      accessKey: "",
      amount: "",
      pakshaPhoto: "",
      allowedColumns: [],
    });
  };

  // ✅ Handle Edit
  const handleEdit = (u) => {
    setFormData({
      fullName: u.fullName,
      mobile: u.mobile,
      role: u.role,
      pad: u.pad,
      accessKey: u.accessKey,
      amount: u.amount,
      pakshaPhoto: u.pakshaPhoto,
      allowedColumns: u.allowedColumns || [],
    });
    setEditingId(u._id);
    setShowForm(true);
  };

  // ✅ Handle Delete
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this Umedwar?"))
      return;
    try {
      const res = await fetch(`${SummaryApi.DeleteUmedwar.url}/${id}`, {
        method: "DELETE",
      });
      const result = await res.json();
      if (res.ok) {
        alert("Deleted successfully!");
        fetchUmedwars();
      } else {
        alert(result.message || "Delete failed");
      }
    } catch (err) {
      console.error("Error deleting Umedwar:", err);
    }
  };

    const handleColumnToggle = (col) => {
    setFormData((prev) => {
      const updated = prev.allowedColumns.includes(col)
        ? prev.allowedColumns.filter((c) => c !== col)
        : [...prev.allowedColumns, col];
      return { ...prev, allowedColumns: updated };
    });
  };

  return (
    <div className="p-6 relative">
      {/* Header Section */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Umedwar List</h1>
        <button
          onClick={() => {
            resetForm();
            setEditingId(null);
            setShowForm(true);
          }}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
        >
          + Create Umedwar
        </button>
      </div>

      {/* Umedwar Table */}
      <div className="overflow-x-auto bg-white shadow-md rounded-xl">
        <table className="min-w-full border border-gray-200">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-2 border">Full Name</th>
              <th className="px-4 py-2 border">Mobile</th>
              <th className="px-4 py-2 border">Role</th>
              <th className="px-4 py-2 border">Pad</th>
              <th className="px-4 py-2 border">Access Key</th>
              <th className="px-4 py-2 border">Amount</th>
              <th className="px-4 py-2 border">Actions</th>
            </tr>
          </thead>
          <tbody>
            {umedwars.length > 0 ? (
              umedwars.map((u) => (
                <tr key={u._id} className="text-center hover:bg-gray-50">
                  <td className="border px-4 py-2">{u.fullName}</td>
                  <td className="border px-4 py-2">{u.mobile}</td>
                  <td className="border px-4 py-2">{u.role}</td>
                  <td className="border px-4 py-2">{u.pad}</td>
                  <td className="border px-4 py-2">{u.accessKey}</td>
                  <td className="border px-4 py-2">₹{u.amount}</td>
                  <td className="border px-4 py-2 flex justify-center gap-2">
                    <button
                      onClick={() => handleEdit(u)}
                      className="px-3 py-1 bg-yellow-500 text-white rounded hover:bg-yellow-600"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(u._id)}
                      className="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-4 text-gray-500">
                  No Umedwar found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Popup Form */}
     {showForm && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-2xl shadow-lg w-[90%] md:w-[450px] max-h-[90vh] overflow-y-auto">
            <h2 className="text-xl font-bold mb-4">
              {editingId ? "Edit Umedwar" : "Create Umedwar"}
            </h2>
            <form onSubmit={handleSubmit} className="flex flex-col gap-3">
              <input
                type="text"
                placeholder="Full Name"
                value={formData.fullName}
                onChange={(e) =>
                  setFormData({ ...formData, fullName: e.target.value })
                }
                className="border p-2 rounded"
                required
              />
              <input
                type="text"
                placeholder="Mobile Number"
                value={formData.mobile}
                onChange={(e) =>
                  setFormData({ ...formData, mobile: e.target.value })
                }
                className="border p-2 rounded"
                required
              />
              <input
                type="text"
                placeholder="Pad (Position)"
                value={formData.pad}
                onChange={(e) =>
                  setFormData({ ...formData, pad: e.target.value })
                }
                className="border p-2 rounded"
                required
              />
              <input
                type="text"
                placeholder="Access Key"
                value={formData.accessKey}
                onChange={(e) =>
                  setFormData({ ...formData, accessKey: e.target.value })
                }
                className="border p-2 rounded"
                required
              />
              <input
                type="number"
                placeholder="Amount"
                value={formData.amount}
                onChange={(e) =>
                  setFormData({ ...formData, amount: e.target.value })
                }
                className="border p-2 rounded"
              />
              <input
                type="text"
                placeholder="Paksha Photo Link (URL)"
                value={formData.pakshaPhoto || ""}
                onChange={(e) =>
                  setFormData({ ...formData, pakshaPhoto: e.target.value })
                }
                className="border p-2 rounded"
              />

              <select
                value={formData.role}
                onChange={(e) =>
                  setFormData({ ...formData, role: e.target.value })
                }
                className="border p-2 rounded"
              >
                <option value="CANDIDATE">CANDIDATE</option>
                <option value="ADMIN">ADMIN</option>
                <option value="SUPERVISOR">SUPERVISOR</option>
                <option value="BOOTH_PRAMUKH">BOOTH_PRAMUKH</option>
                <option value="WARD_MEMBER">WARD_MEMBER</option>
              </select>

              {/* ✅ Allowed Columns Selection */}
              <div>
                <p className="font-semibold mb-1">Allowed Columns:</p>
                <div className="grid grid-cols-2 gap-1 max-h-[120px] overflow-y-auto border p-2 rounded">
                  {allColumns.map((col) => (
                    <label key={col} className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={formData.allowedColumns.includes(col)}
                        onChange={() => handleColumnToggle(col)}
                      />
                      <span>{col}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div className="flex justify-end gap-3 mt-3">
                <button
                  type="button"
                  onClick={() => {
                    setShowForm(false);
                    setEditingId(null);
                  }}
                  className="px-4 py-2 bg-gray-300 rounded"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  {editingId ? "Update" : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default UmedwarPage;
